import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StationsRepo } from 'src/app/repositories/station-repo';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { Station, Subscription } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-subscription',
    templateUrl: './modal-delete-subscription.component.html',
    styleUrls: ['./modal-delete-subscription.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteSubscriptionComponent implements OnDestroy {
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public subscription: Subscription,
    private subscriptionRepo: SubscriptionRepo,
    private translate: TranslateService,
    private router: Router
  ) {}

  deleteSubscription() {
    this.loading = true;
    this.subscriptionRepo
      .deleteSubscription(this.subscription.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('subscriptions.delete.success');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('subscriptions.delete.error');
        });
  }

  ngOnDestroy() {
  }
}
